import { Link } from '@ksyos/router';
import type { IServiceGraderPool } from '../../interfaces/serviceGraderPoolInterfaces';
import { DeleteButton, TableData, TableRow } from '../../../../elements/common';

interface IProps {
    onDelete: (id: string) => void;
    serviceGraderPool: IServiceGraderPool;
    serviceId: string;
}

export function ServiceGraderPoolListRow(props: IProps) {
    const { serviceGraderPool, serviceId } = props;
    const linkTo = `/serviceGraderPools/${serviceGraderPool.id}?serviceId=${serviceId}`;

    return (
        <TableRow>
            <TableData>
                <Link to={linkTo}>{serviceGraderPool.name}</Link>
            </TableData>
            <TableData align="right">
                <DeleteButton
                    onClick={() => {
                        props.onDelete(serviceGraderPool.id!);
                    }}
                />
            </TableData>
        </TableRow>
    );
}
